import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Container, Typography, Grid } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const TrustSection = () => {
  const { t } = useTranslation();
  const { lng } = useParams();

  const principles = [
    {
      title: t('home.trust.principle1Title'),
      description: t('home.trust.principle1Desc'),
    },
    {
      title: t('home.trust.principle2Title'),
      description: t('home.trust.principle2Desc'),
    },
    {
      title: t('home.trust.principle3Title'),
      description: t('home.trust.principle3Desc'),
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#F7F9FC',
        pt: { xs: 5, sm: 6, md: 7 },
        pb: { xs: 5, sm: 6, md: 7 },
      }}
    >
      <Container
        maxWidth={false}
        sx={{ maxWidth: '960px', mx: 'auto', px: { xs: 2, md: 3 } }}
      >
        {/* Section title */}
        <Typography
          variant="h3"
          align="center"
          sx={{ fontWeight: 600, color: '#1A1A1A', mb: 2 }}
        >
          {t('home.trust.title')}
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ color: '#1A1A1A', mb: 4, maxWidth: '560px', mx: 'auto' }}
        >
          {t('home.trust.subtitle')}
        </Typography>

        {/* Principles cards */}
        <Grid container spacing={2.5} sx={{ mb: 4 }}>
          {principles.map((p) => (
            <Grid item xs={12} md={4} key={p.title}>
              <Box
                sx={{
                  p: 2.5,
                  borderRadius: '14px',
                  border: '1px solid #E6E9EE',
                  backgroundColor: '#FFFFFF',
                  height: '100%',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#1A1A1A',
                    mb: 1,
                    lineHeight: '20px',
                  }}
                >
                  {p.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '13px',
                    color: '#1A1A1A',
                    lineHeight: '20px',
                  }}
                >
                  {p.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Disclosure module - Layer 3 persistent */}
        <Box
          sx={{
            backgroundColor: '#FAFBFD',
            border: '1px solid #E6E9EE',
            borderRadius: '10px',
            p: 3,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
          }}
        >
          <InfoIcon sx={{ fontSize: '16px', color: '#5F6B7A', mt: '2px', flexShrink: 0 }} />
          <Box>
            <Typography
              sx={{ fontSize: '13px', color: '#1A1A1A', lineHeight: '20px', mb: 0.5 }}
            >
              {t('home.trust.disclosure')}
            </Typography>
            <Typography
              component={RouterLink}
              to={`/${lng}/como-monetizamos`}
              sx={{
                fontSize: '12px',
                color: '#1E3A5F',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              {t('home.trust.disclosureLink')}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TrustSection;
